import React from 'react'
import { propTypes } from 'react-bootstrap-editable'

const RaisedButton = (
    {name, className,onClick}
) => {
  return (
    <button className={className} onMouseDown={(e) => {
        e.target.classList.remove("raised-btn")
     }} onMouseUp={(e) => {
        e.target.classList.add("raised-btn")
     }} onClick={(e) => onClick(e)}>{name}</button>
  )
}

export default RaisedButton

